import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, Button, DialogFooter} from '@taopix/taopix-design-system';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';

export type CloseCellEditorDialogProps = {
  open: boolean;
  onSave: () => void;
  onDontSave: () => void;
};

const CloseCellEditorDialog = ({open, onSave, onDontSave}: CloseCellEditorDialogProps) => {
  const {t} = useTranslation(['calendarevent', 'dialogs']);
  const ui = useUiState();

  // onSave - updateCalendar?

  return (
    <Dialog
      open={open}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('dialogs:str_TitleSaveEventBeforeClosing', {
        defaultValue: 'Save Event Before Closing',
      })}
      showTitle={false}
      aria-live="assertive"
    >
      <DialogContent>{t('calendarevent:str_MessageSaveEventBeforeClosing')}</DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button label={t('*:str_ButtonDontSave')} buttonStyle={'secondary'} onClick={onDontSave} />
        <Button label={t('calendarevent:str_ButtonSaveEvent')} onClick={onSave} />
      </DialogFooter>
    </Dialog>
  );
};

export default CloseCellEditorDialog;
